<script>
    import user from './stores/user';
    import {router} from './router/Router.svelte';
    import CheckboxControl from './controls/CheckboxControl.svelte';
    import MessagesSentRow from "./MessagesSentRow.svelte";
    import Pagination from "./Pagination.svelte";
    import {getMessagesSent} from "./requests";

    export let page = 1;
    let sentMessages = [];
    let totalMessages = null;
    let totalPages = null;
    let search = {
        all_messages: false,
        username: "",
    }

    const close = () => {
        router._go("/app");
    }

    const loadData = async (p) => {

        const [err, res] = await getMessagesSent(page, search);

        if (err) {
            return;
        }

        sentMessages = res.list;
        totalMessages = res.total;
    }

    const handleCancel = event => {
        alert("cancel message " + event.detail.id);
    }

    const clearSearch = () => {
        search = {
            all_messages: false,
            username: "",
        }
    }

    $: {
        loadData(page);
    }
</script>

<div class="page-header">
    <div class="page-title">Απεσταλμένα Μηνύματα</div>
    <div class="controls">
        <div title="Ανανέωση λίστας" on:click|preventDefault="{ loadData }">
            <span class="icon"><i class="fa fa-refresh"></i></span>
            <span class="caption">Ανανέωση</span>
        </div>
        <div title="Κλείσιμο" on:click|preventDefault="{ close }">
            <span class="icon"><i class="fa fa-times"></i></span>
        </div>
    </div>
</div>

<div class="page">
    <div class="page-main">
        <div class="content">

            {#if $user.is_admin}
                <div class="panel">
                    <div class="panel-heading">
                        ΑΝΑΖΗΤΗΣΗ
                    </div>
                    <div class="panel-body">
                        <div class="row">
                            <div class="col-md-3 col-xs-6">
                                <div class="form-group">
                                    <label>ΕΜΦΑΝΙΣΗ</label>
                                    <CheckboxControl label="Όλων των πελατών" bind:checked="{ search.all_messages }"/>
                                </div>
                            </div>

                            <div class="col-md-3 col-xs-6">
                                {#if search.all_messages}
                                    <div class="form-group">
                                        <label>ΛΟΓΑΡΙΑΣΜΟΣ</label>
                                        <input type="text" class="form-control" bind:value="{ search.username }">
                                    </div>
                                {/if}
                            </div>

                            <div class="col-md-6 col-xs-12 text-right">
                                <div class="label-spacer"></div>
                                <button class="btn btn-primary block-for-xs" on:click="{ loadData }">ΕΥΡΕΣΗ</button>
                                <button class="btn btn-default block-for-xs mrg-b-none" on:click="{ clearSearch }">
                                    ΚΑΘΑΡΙΣΜΟΣ
                                </button>
                            </div>
                        </div>

                    </div>
                </div> <!-- /search -->
            {/if}

            <div class="panel">
            <div class="panel-heading hidden-xs">
                MHNYMATA
                {#if (totalMessages > 0)}
                    <span class="total">({ totalMessages })</span>
                {/if}
            </div>
            {#if sentMessages.length}
                <div class="table-responsive">
                    <table class="table table-bordered table-list table-data mrg-b-none">
                        <thead>
                        <tr>
                            <th>Αποστολή</th>
                            {#if $user.is_admin}
                                <th>Λογαριασμός</th>
                            {/if}
                            <th>Αποστολέας</th>
                            <th>Μήνυμα</th>
                            <th class="text-right">Παραλήπτες</th>
                            <th class="text-right">Αρ. Αναφορών</th>
                            {#if $user.is_admin}
                                <th>Από</th>
                            {/if}
                            <th>&nbsp;</th>
                        </tr>
                        </thead>
                        <tbody>
                        {#each sentMessages as message}
                            <MessagesSentRow message="{ message }" on:cancel="{ handleCancel }"/>
                        {/each}
                        </tbody>
                    </table>
                </div>

            {:else}
                <div class="panel-body">
                    <p>Δεν υπάρχουν απεσταλμένα μηνύματα</p>
                </div>
            {/if}

            {#if totalMessages}
                <div class="panel-body">
                    <div class="nav-pagination text-right">
                        <Pagination
                                target="messagessent"
                                page="{ page }"
                                itemsPerPage="50"
                                totalItems="{ totalMessages }"/>
                    </div>
                </div>
            {/if}

        </div>
        </div>
    </div> <!-- /page-main -->
</div>
